import React, { useState } from 'react';

const SelectNetworkFreightReport = ({ fetchReports, theme }) => {
    const [consignmentNumber, setConsignmentNumber] = useState('');
    const [error, setError] = useState('');
    const isLightTheme = theme === 'light';

    const handleSubmit = (event) => {
        event.preventDefault();
        const value = consignmentNumber.trim();
        if (!value) {
            setError('Please enter a consignment number.');
            return;
        }
        setError('');
        fetchReports(value);
    };

    return (
        <form onSubmit={handleSubmit} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            justifyContent: 'center',
            alignItems: 'center',
            margin: '20px auto',
            padding: '40px',
            width: '100%',
            border: '2px solid #7c3aed',
            borderRadius: '8px',
            minHeight: '290px',
        }}>
            <h2>Network Freight Search</h2>
            <label htmlFor="network-consignment-number" style={{ fontSize: 14, fontWeight: 'bold' }}>
                Consignment Number
            </label>
            <input
                id="network-consignment-number"
                type="text"
                value={consignmentNumber}
                onChange={(event) => setConsignmentNumber(event.target.value)}
                placeholder="Enter customer consignment number"
                autoComplete="off"
                style={{
                    padding: '8px',
                    textAlign: 'center',
                    backgroundColor: isLightTheme ? '#fff' : '#333',
                    color: isLightTheme ? '#333' : '#fff',
                    width: '100%',
                    border: `1px solid ${isLightTheme ? '#aaa' : '#666'}`,
                    borderRadius: '4px',
                }}
            />
            <button type="submit" className="hoverable" style={{
                padding: '8px 12px',
                width: '100%',
                backgroundColor: '#7c3aed',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
            }}>
                Search
            </button>
            {error && <p style={{ color: '#dc3545', margin: 0, fontSize: 14 }}>{error}</p>}
        </form>
    );
};

export default SelectNetworkFreightReport;